import React, { Component } from "react";
import { connect } from "react-redux";
import { contactPublic, loadData } from "../../../domain/contact/contactActions";
import ContactForm from "../../forms/public/ContactForm/ContactForm";
import StatusMessage from "../../presentational/StatusMessage";
import * as StatusMessages from "../../../constants/StatusMessages";
import { FormattedMessage } from "react-intl";
import PhoneLink from "../../presentational/PhoneLink";
import { resetMessages } from "../../../domain/misc/miscActions";
import ContactHoursOfOperation from "../../presentational/ContactHoursOfOperation/ContactHoursOfOperation";
import track from "react-tracking";
import MDPatientSheet from "../../common/MDPatientSheet/MDPatientSheet";
class ContactPublic extends Component {
    componentDidMount() {
        this.props.loadData();
        this.props.resetMessages("contact");
    }
    render() {
        const contactData = this.props.contactData || {
            docTypes: [],
            captchaRequired: false
        };
        return (<div className="wrapper wrapper_narrow">
				<div className="vr vr_x4">
					<h2 className="hdg js-pageHeader">
						<FormattedMessage id="contact.public.header" defaultMessage="Contact Us"/>
					</h2>
				</div>

				<StatusMessage isError isActive={this.props.contactDataError} customMessage={StatusMessages.CONTACT.DATA_LOAD_FAILED} domain="contact" autoReset={false}/>

				<StatusMessage isError isActive={this.props.contactError ? true : false} error={this.props.contactError ? this.props.contactError : null} customMessage={StatusMessages.CONTACT.INTRO_CONTACT} domain="contact" autoReset={false}/>

				<div className="vr vr_x5">
					<div className="text">
						<p>
							<FormattedMessage id="contact.public.message" defaultMessage="To contact us, please fill out the form below, or give us a call at {phone}." values={{
            phone: <PhoneLink />
        }}/>
						</p>
						<div style={{ paddingTop: "10px" }}>
							<span style={{ paddingBottom: "8px", fontWeight: 600, display: "block" }}>
								<FormattedMessage tagName="h2" id="notice.languageServices.title" defaultMessage="For New York City Residents"/>
							</span>

							<FormattedMessage id="notice.languageServices" defaultMessage={"DCM Services does not offer language access services.  However, we do offer translation of verbal and written communications into Spanish but on a limited basis. Translation and description of common debt collection terms is available in multiple languages on the Department of Consumer Affairs website, {link}."} values={{
            link: <a className="link" href="http://www.nyc.gov/dca">www.nyc.gov/dca</a>
        }}/>
						</div>
					</div>
				</div>

				<StatusMessage isLoad isActive={this.props.contactDataLoading}/>

				<ContactHoursOfOperation />

				<div className="vr vr_x5">
					<ContactForm sendToAPI={this.props.contactPublic} fieldErrors={this.props.contactFieldErrors} isLoading={this.props.contactIsLoading || this.props.contactDataLoading} documentTypes={contactData.docTypes} captchaRequired={contactData.captchaRequired} locale={this.props.locale} refNumber={this.props.account === undefined ? undefined : this.props.account.referenceNumber}/>
				</div>
				{process.env.CLIENT !== "CapOne" && (<div style={{ paddingBottom: "25px", textAlign: "center" }}>
						<FormattedMessage id="notice.miniMiranda" defaultMessage="DCM Services is a debt collection agency attempting to collect a debt. Any information obtained will be used for that purpose."/>
					</div>)}
				<StatusMessage isLoad isActive={this.props.contactIsLoading}/>
				{this.props.account && this.props.account.hasMDPatientInfoSheet && (<MDPatientSheet clientId={this.props.account.clientId} clientName={this.props.account.clientName} hasSpanish={this.props.account.hasMDPatientInfoSheetES}/>)}
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    contactError: state.contact.error,
    contactFieldErrors: state.contact.fieldErrors,
    contactIsLoading: state.contact.isLoading,
    contactIsSuccess: state.contact.isSuccess,
    contactData: state.contact.contactData,
    contactDataLoading: state.contact.contactDataLoading,
    contactDataError: state.contact.contactDataError,
    locale: state.i18n.locale
});
const bindActionsToProps = {
    contactPublic,
    resetMessages,
    loadData
};
/* Create and export container component that wraps ContactPublic for property binding */
export default track({ page: "ContactPublic" }, { dispatchOnMount: true })(connect(mapStateToProps, bindActionsToProps)(ContactPublic));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/ContactPublic.tsx